import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '@/store/base-store.repository';
import { userStateInitialState, UserStateProps, userStateStore } from '@/store/user-state/user-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class UserRepository extends BaseStoreRepository<UserStateProps> {
  constructor() {
    super(userStateStore.pipe(select(state => state)), userStateStore, userStateInitialState);
  }
}
